import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export const ModalDeleteServicio = (props) => {
	const {UseModalDeleteServicio, setUseModalDeleteServicio, deleteServicio} = props;

	return (
		<>
			<Modal
				centered={true}
				isOpen={UseModalDeleteServicio}
				toggle={() => setUseModalDeleteServicio(false)}
			>
				<ModalHeader>
					<b>Eliminar servicio</b>
				</ModalHeader>
				<ModalBody>¿Seguro que desea eleminar este servicio?</ModalBody>
				<ModalFooter>
					<div className='buttons-modal-categoria'>
						<div
							className='button'
							onClick={() => setUseModalDeleteServicio(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => deleteServicio()}
						>
							<b>Eliminar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
